

<section class="bg-light pt-3 pb-3">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <h2 class="mb-0 small-21">Search ({{ keywords }})</h2>
            </div>
        </div>
    </div>
</section>

<!--  -->
<section class="mt-3 mb-5">
    <div class="container-fluid">
        <div class="row">
           
            <div class="col-md-12">

                <div *ngIf="types.length > 0">
                    <ngb-tabset [destroyOnHide]="false">
                        <ngb-tab title="{{type | titlecase }}" *ngFor="let type of types">
                            <ng-template ngbTabContent>
                                <div class="row f-details">
                                    <div class="col-md-3" *ngFor="let result of searchResult[type]; let _i = index">
                                        <div class="row">
                                            <div class="col-md-12 col-5" *ngIf="result.searchable.images  && type=='products'">
                                                <a [routerLink]="['/', result.searchable.slug, result.searchable.sku]">
                                                    <img [src]="result.searchable.images | baseImage | imagePath" class="img-fluid mb-4 mx-auto d-block img-height" alt="img" />
                                                </a>
                                            </div>

                                            <div class="col-md-12 col-5" *ngIf="result.searchable.image && type=='brands'">
                                                <a routerLink="/wheelbrand/{{result.title}}" [queryParams]="{'brand': result.title }">
                                                    <img [src]="result.searchable.image | imagePath" class="img-fluid mb-4 mx-auto d-block img-height" alt="img" />
                                                </a>
                                            </div>

                                            <div class="col-md-12 col-7">
                                                <p class="f2">
                                                    <span>{{result.title}}</span>
                                                </p>
                                            </div>
                                        </div>
                                        <hr *ngIf="(i+1) % 4 == 0" style="width:96%; margin-bottom: 30px" />
                                    </div>
                                </div>
                            </ng-template>
                        </ngb-tab>
                    </ngb-tabset>
                </div>
                <app-preloader *ngIf="types.length <= 0"></app-preloader>
            </div>
        </div>
    </div>
</section>
<!--  -->